module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "d08649ec90568-d1e215"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("A Selection of Recent Titles by Graham Masterton available from Severn House")])]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("The Sissy Sawyer Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("TOUCHY AND FEELY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE PAINTED MAN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("THE RED HOTEL")]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("The Jim Rook Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("DEMON’S DOOR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("GARDEN OF EVIL")]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("The Harry Erskine Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("MANITOU BLOOD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("BLIND PANIC")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("PLAGUE OF THE MANITOU")]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("The Night Warriors Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("THE NINTH NIGHTMARE")]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("Anthologies")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("FESTIVAL OF FEAR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("FIGURES OF FEAR")]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("Novels")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("BASILISK")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("FIRE SPIRIT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("PETRIFIED")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("COMMUNITY")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("FOREST GHOST")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("DROUGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2fd2aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106588_epub_alb.vue
// module id = 63
// module chunks = 0